/**
 * Touch-friendly navigation for tablets
 * Blocks navigation when clicking the chevron and toggles mega menu
 */

document.addEventListener('DOMContentLoaded', () => {
	// Find ALL site-nav elements (there are multiple - left and right of logo)
	const siteNavs = document.querySelectorAll('site-nav');
	if (!siteNavs.length) return;

	const header = document.querySelector('.site-header');

	// For each site-nav, find all chevron arrows
	siteNavs.forEach(siteNav => {
		const arrows = siteNav.querySelectorAll('.f-site-nav__arrow');

		// Block click event on chevrons to prevent navigation
		arrows.forEach(arrow => {
			arrow.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();

				// Find the parent menu item
				const menuItem = arrow.closest('.f-site-nav__item');
				if (!menuItem) return;

				// Check if menu is currently open
				const isOpen = menuItem.classList.contains('f-menu__item-active');

				if (isOpen) {
					// Close the menu
					menuItem.classList.remove('f-menu__item-active');

					// If it's a mega menu item, deactivate the header backdrop
					if (menuItem.classList.contains('f-site-nav__item--mega') && header) {
						header.handleMegaItemDeactive();
					}
				} else {
					// Close all other open menus first
					siteNavs.forEach(nav => {
						nav.querySelectorAll('.f-site-nav__item').forEach(item => {
							item.classList.remove('f-menu__item-active');
						});
					});

					// Open this menu
					menuItem.classList.add('f-menu__item-active');

					// If it's a mega menu item, activate the header backdrop
					if (menuItem.classList.contains('f-site-nav__item--mega') && header) {
						const dropdown = menuItem.querySelector('.f-site-nav__dropdown');
						if (dropdown) {
							header.handleMegaItemActive(dropdown);
						}
					}
				}
			});
		});
	});
});
